import AxiosService from './AxiosService'

class BGTaskScheduleRestService {

    get(): Promise<any> {
        return AxiosService.get('/backgroundtasks/schedules')
    }

    getById(id: number): Promise<any> {
        return AxiosService.get('/backgroundtasks/schedules/' + id)
    }
    getDefinitions(): Promise<any> {
        return AxiosService.get('/backgroundtasks/schedules/definitions')
    }

    getDefinitionByType(type: string): Promise<any> {
        return AxiosService.get('/backgroundtasks/schedules/definitions/' + type)
    }

    getRecentBGTasksOfSchedule(scheduleId: number, limit: any): Promise<any> {
        return AxiosService.get('/backgroundtasks/schedules/' + scheduleId + '/recentTasks?limit=' + limit)
    }

    create(schedule: any): Promise<any> {
        return AxiosService.post('/backgroundtasks/schedules/', schedule)
    }

    update(schedule: any): Promise<any> {
        return AxiosService.put('/backgroundtasks/schedules/' + schedule.id, schedule)
    }

    delete(id: number): Promise<any> {
        return AxiosService.delete('/backgroundtasks/schedules/' + id)
    }

    createConfig(schedule: any): Promise<any> {
        return AxiosService.post('/backgroundtasks/schedules/configs/' + schedule.bgiSchedule, schedule)
    }

    updateConfig(schedule: any): Promise<any> {
        return AxiosService.put('/backgroundtasks/schedules/configs/', schedule)
    }

    deleteConfig(id: number): Promise<any> {
        return AxiosService.delete('/backgroundtasks/schedules/configs/' + id)
    }

    getAllFieldConfigs(): Promise<any> {
        return AxiosService.get('/backgroundtasks/schedules/configs/')
    }
}

export default new BGTaskScheduleRestService()
